import Widgets from '@/widgets'


export default [
	{name:'first_name',   widget:Widgets.input, attrs: { type:'text',     required:true,  placeholder:"Ваше имя" },             icon:"icon-user" },
	{name:'last_name',    widget:Widgets.input, attrs: { type:"text",     required:true,  placeholder:"Ваша фамилия" },         icon:"icon-user" },
	{name:'organisation', widget:Widgets.input, attrs: { type:"text",     required:true,  placeholder:"Название организации" }, icon:"icon-briefcase" },
	{name:'email',        widget:Widgets.input, attrs: { type:"email",    required:false, placeholder:"Электронная почта" },    icon:"icon-cursor" },
	{name:'password',     widget:Widgets.input, attrs: { type:"password", required:true,  placeholder:"Пароль" },               icon:"icon-lock" },
	{name:'password2',    widget:Widgets.input, attrs: { type:"password", required:true,  placeholder:"Подтверждение пароля" }, icon:"icon-lock" },
]
